export const statsProxyPath = '/jetpack-premium-analytics/v1/proxy';
